/**
 * Сервис для работы с аутентификацией админа
 */

import { getApiUrl } from './apiBase';

const API_URL = getApiUrl();

let adminToken: string | null = null;

/**
 * Войти в админ-панель
 */
export async function loginAdmin(key: string): Promise<{ success: boolean; error?: string; attemptsLeft?: number }> {
  try {
    const response = await fetch(`${API_URL}/auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ key }),
    });

    const data = await response.json();

    if (response.ok && data.success) {
      adminToken = data.token;
      localStorage.setItem('adminToken', data.token);
      return { success: true };
    } else {
      return { 
        success: false, 
        error: data.error || 'Ошибка входа',
        attemptsLeft: data.attemptsLeft
      };
    }
  } catch (error) {
    console.error('Login error:', error);
    return { success: false, error: 'Ошибка подключения к серверу' };
  }
}

/**
 * Проверить статус аутентификации
 */
export async function checkAuth(): Promise<boolean> {
  try {
    const token = adminToken || localStorage.getItem('adminToken');
    if (!token) {
      return false;
    }

    const response = await fetch(`${API_URL}/auth/check`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
      credentials: 'include',
    });

    const data = await response.json();
    return data.authenticated === true;
  } catch (error) {
    return false;
  }
}

/**
 * Выйти из админ-панели
 */
export function logoutAdmin(): void {
  adminToken = null;
  localStorage.removeItem('adminToken');
}

/**
 * Получить токен для запросов
 */
export function getAuthToken(): string | null {
  return adminToken || localStorage.getItem('adminToken');
}

